import {requestSMSCode, checkSMSCode} from "@/store/api/api";

export default {
    namespaced: true,
    state: {
        isVerified: false,                  // код прошел проверку
        isError: false,                     // наличие ошибки при запросе
        errorText: '',                      // текст ошибки из запроса
        isOfferAccepted: false              // принятие офферты
    },
    getters: {
        getVerificationState(state) {
            return state.isVerified;
        },
        getErrorState(state) {
            return state.isError;
        },
        getErrorText(state) {
            return state.errorText;
        },
        getIsOk(state) {
            return state.isVerified && state.isOfferAccepted;
        },
        getOfferState(state) {
            return state.isOfferAccepted;
        }
    },
    mutations: {
        setVerificationState(state, payload) {
            state.isVerified = payload;
        },
        setErrorState(state, payload) {
            state.isError = payload;
        },
        setErrorText(state, payload) {
            state.errorText = payload;
        },
        setOfferState(state, payload) {
            return state.isOfferAccepted = payload;
        }
    },
    actions: {
        // (Возможно в будущем нужно будет выводить данные пользователя для аутентификации)
        // getUser() {},
        async requestCode({commit}, {phone}) {
            const {status, error_message} = await requestSMSCode({phone});
            if (!status) {
                commit('setErrorState', true);
                commit('setErrorText', error_message || 'Произошла ошибка');
            } else {
                commit('setErrorState', false);
                commit('setErrorText', '');
            }
            return status;
        },
        async checkCode({commit}, {phone, code}) {
            const {status, is_success, error_message} = await checkSMSCode({phone, code});
            // Если запрос накрылся
            if (!status) {
                commit('setErrorState', true);
                commit('setErrorText', error_message || 'Произошла ошибка');
                // Если код верный
            } else if (is_success) {
                commit('setVerificationState', true);
                commit('setErrorState', false);
                commit('setErrorText', '');
                // Если код НЕ подтвержден
            } else {
                commit('setVerificationState', false);
                commit('setErrorState', true);
                commit('setErrorText', error_message || 'Некорректный код');
            }
        },
    }
}
